import InputTypeBasic from './basic'
import InputTypeDetailed from './detailed'
import InputTypeDisplay from './input-type-display'
import DeleteConfirmation from "./delete-modal"
import WithinLease from './within-lease'

export default {
  InputTypeBasic,
  InputTypeDetailed,
  InputTypeDisplay,
  DeleteConfirmation,
  WithinLease
}